export default "__VITE_ASSET__dWvTEjZx__"